{
  "contact-details": {
    "email": "ईमेल पता",
    "mobilePhone": "मोबाइल फ़ोन",
    "nextLabel": "$t(common:next): <b>आपके जीपी (डॉक्टर)</b>",
    "otherPhone": "अन्य फ़ोन",
    "text": "हम आपसे संपर्क करने के लिए इन विवरणों का उपयोग कर रहे हैं, लेकिन यदि आवश्यक हो तो आप इन्हें अपडेट कर सकते हैं।",
    "title": "आपकी संपर्क जानकारी"
  },
  "doctor": {
    "gp": "जीपी (डॉक्टर) का नाम",
    "manually": "डॉक्टर दिखाई नहीं दे रहा है? <PrimaryText>इसे मैन्युअली दर्ज करें...</PrimaryText>",
    "medicalCentre": "चिकित्सा केंद्र",
    "nextLabel": "$t(common:next): <b>आपका आपातकालीन संपर्क</b>",
    "searchPlaceholder": "अपने जीपी या चिकित्सा केंद्र की खोज करें",
    "text": "क्या यह आपके जीपी हैं? यदि नहीं, तो कृपया अपडेट करें।",
    "title": "आपके जीपी (डॉक्टर)"
  },
  "emergency": {
    "fullName": "पूरा नाम",
    "mobileNumber": "मोबाइल नंबर",
    "nextLabel": "$t(common:next): <b>बीमा / कौन भुगतान कर रहा है</b>",
    "relationship": "आपसे संबंध",
    "select": {
      "child": "बच्चा",
      "friend": "मित्र",
      "other": "अन्य",
      "parent": "माता-पिता",
      "spouse": "पति / पत्नी या साथी"
    },
    "text": "आपात स्थिति में हम किससे संपर्क करें?",
    "title": "आपातकालीन संपर्क"
  },
  "home-address": {
    "building": "इमारत या उपखंड का स्तर, मंज़िल या इकाई",
    "city": "शहर / नगर",
    "manually": "पता नहीं दिख रहा है? <PrimaryText>इसे मैन्युअली दर्ज करें...</PrimaryText>",
    "nextLabel": "$t(common:next): <b>आपकी संपर्क जानकारी</b>",
    "postcode": "पिन कोड",
    "searchPlaceholder": "न्यूज़ीलैंड में पता खोजें",
    "street": "सड़क का नाम और नंबर",
    "suburb": "उपनगर या आरडी (ग्रामीण डिलीवरी)",
    "text": "कृपया अपना घर का पता दर्ज करें:",
    "textSecondary": "यह पता है जिसका हम उपयोग करेंगे:",
    "title": "आपका घर का पता"
  },
  "name-birthdate": {
    "birthDate": "जन्म तिथि",
    "dateFormat": "dd/mm/yyyy",
    "familyName": "परिवार का नाम:",
    "firstName": "पहला नाम (नाम)",
    "nextLabel": "$t(common:next): <b>आपका NHI और निवास स्थिति</b>",
    "preferredName": "पसंदीदा नाम",
    "select": {
      "label": "उपाधि",
      "mr": "Mr",
      "ms": "Ms",
      "mx": "Mx",
      "placeholder": "अपना उपाधि चुनें"
    },
    "text": "कृपया इन विवरणों की जांच करें और जो भी ग़लत या अधूरा हो, उसे अपडेट करें:",
    "title": "आपका नाम और जन्मतिथि"
  },
  "nhi-residency": {
    "nextLabel": "$t(common:next): <b>आपका घर का पता</b>",
    "nhiNumber": "NHI नंबर (राष्ट्रीय स्वास्थ्य सूचकांक संख्या)",
    "resident": "क्या आप न्यूज़ीलैंड के निवासी हैं?",
    "residentText": "यदि आप न्यूज़ीलैंड के निवासी नहीं हैं, तो आपको कुछ सेवाओं जैसे कि लैब जांच के लिए शुल्क लिया जा सकता है।",
    "text": "कृपया जांचें और कोई भी गुम या गलत जानकारी अपडेट करें:",
    "title": "आपका NHI और निवास स्थिति"
  }
}
